import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import SupervisorApi from "../../utility/supervisorApi";
import { useMutation } from "@tanstack/react-query";

function EditStore({ item }) {
  const { updateData } = SupervisorApi();
  const [data, setData] = useState({
    store_name: item?.storeName || "",
    location: item?.location || "",
    color_code: item?.colorCode || "",
  });
  const [edittab, setEdittab] = useState(false);
  const [loading, setLoading] = useState(false);

  const editData = useMutation({
    mutationFn: (formData) =>
      updateData("store-management/update/", item.id, formData),
    onSuccess: () => {
      setEdittab(false);
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    editData.mutate(data);
  };

  // Reset form data when closing edit tab
  const handleCloseEdit = () => {
    setEdittab(false);
  };

  return (
    <>
      <EditIcon
        // onClick={() => setEdittab(true)}
        className="text-blue-500 cursor-pointer"
      />

      {edittab && (
        <div className="fixed inset-0 flex items-center justify-center  bg-black bg-opacity-50">
          <form onSubmit={handleEditSubmit} className="p-6 bg-white rounded-lg">
            <div className="flex justify-end">
              <CloseIcon
                className="cursor-pointer text-black"
                onClick={handleCloseEdit}
              />
            </div>

            <h4 className="text-xl font-semibold mb-3 text-black">
              Edit Store Details
            </h4>
            <div className="flex flex-col  gap-6">
              <div className="flex flex-col gap-1 items-start">
                <label htmlFor="store_name">Store Name</label>
                <input
                  id="store_name"
                  className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
                  placeholder="Store Name"
                  type="text"
                  name="store_name"
                  value={data.store_name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="flex flex-col  gap-1 items-start">
                <label htmlFor="location">Location</label>
                <input
                  id="location"
                  className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
                  placeholder="Location"
                  type="text"
                  name="location"
                  value={data.location}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* <div className="flex flex-col gap-1 items-start">
                <label htmlFor="color_code">Color Code</label>
                <input
                  id="color_code"
                  className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
                  placeholder="Color Code"
                  type="text"
                  name="color_code"
                  value={data.color_code}
                  onChange={handleChange}
                  required
                />
              </div> */}
            </div>

            <div className="flex justify-center mt-6 text-white font-medium text-xl p-3 bg-darkblue rounded-lg">
              <button
                type="submit"
                disabled={loading}
                className="w-full h-full"
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default EditStore;
